module.exports = __webpack_public_path__ + "img/popup-btn2.d87841a0.png";